/**
 * アイコン情報更新
 *
 * @export UpdateCwsIconDataVo
 * @class UpdateCwsIconDataVo
 */
export class UpdateCwsIconDataVo {
    constructor(
        public iconCode: string,
        public iconName: string,
        public groupCode: string,
        public iconDiv: string,
        public arrangeDiv: string,
        public iconExplain: string,
        public outputDiv: string,
    ) {}
}
